import { useAppSelector } from '@app/redux/hooks';
import { selectRegion } from '@app/redux/slices/header';
import { ECommerceProduct } from '@app/services/ServiceEcommerce';
import { useRouter } from 'next/router';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { AdBannerImage } from './AdBannerImage';
import data from './ads';

import { ErrorBoundaryComponent } from '@app/shared/ui/ErrorBoundary';
import { RegionTypes } from '@app/Types/Region';
import classNames from 'classnames';
import styles from './Ad.module.scss';

interface IAdProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  slot?: string;
  items?: ECommerceProduct[];
}

export const Ad = ({ slot, items, ...props }: IAdProps): JSX.Element => {
  const router = useRouter();
  const { REGION: regionId, REGION_TYPE: regionType } = useAppSelector(selectRegion);
  const href = router.asPath || '/';
  const matches = data
    .filter(x => !x.regions || x.regions.includes(+regionId))
    .filter(x => !x.excludeRegions || !x.excludeRegions.includes(+regionId))
    .filter(x => {
      const re = new RegExp(x.href);
      if (re.test(href)) {
        if (!slot) {
          return true;
        } else if (slot && x.slot === slot) {
          return true;
        }
      }

      return false;
    })
    .filter(x => (x?.isHideRegionsPvz ? regionType === RegionTypes.Branch : x));

  let banner = null;

  // If we have matches with regions, take first of them
  matches?.forEach(match => {
    banner = match.regions?.length ? match?.banners?.[0] : null;
  });

  // Otherwise, take the first
  if (!banner) {
    banner = matches?.[0]?.banners?.[0];
  }

  if (!banner) {
    return null;
  }

  return (
    <div
      className={classNames(
        styles.Ad,
        {
          [styles.isHref]: !!banner.href || !!banner.handlerAction,
        },
        props.className,
      )}
      {...props}
    >
      <ErrorBoundaryComponent>
        <AdBannerImage banner={banner} items={items} />
      </ErrorBoundaryComponent>
    </div>
  );
};
